export const getPathWithParams = ({
	path,
	params,
	app,
}: {
	path: string;
	params: { [index: string]: string };
	app: 'business' | 'panelist' | 'interviewer' | 'admin' | '';
}) => {
	let output = path;
	const searching = Object.entries(params);

	searching.forEach(([param, value]) => {
		if (output.includes(`:${param}?`)) {
			output = output.replace(`:${param}?`, value);
		} else {
			output = output.replace(`:${param}`, value);
		}
	});
	if (!app) return output;

	return `/${app}${output}`;
};
